import { appliedFiltersAtom } from '@pages/VendorsSearch/containers/FilterPills/atoms';
import { useAppSelector } from '@redux/hooks';
import { SearchConstants } from '@settings';
import { useAtomValue } from 'jotai';
import { useMemo } from 'react';

export const useSpotlightDisplay = () => {
	const appliedFilters = useAtomValue(appliedFiltersAtom);
	const isMobile = useAppSelector((state) => state.viewport.isMobile);
	const sort = useAppSelector((state) => state.search.sort);
	const isCurrentBowFilterApplied = useMemo(
		() =>
			appliedFilters.some((f) => {
				const { config, value } = f.getData();
				if (config.id !== 'best-of-weddings') return false;
				if (Array.isArray(value)) {
					return value.some((facet) => facet.facetValue === 'current-winner');
				}
				return false;
			}),
		[appliedFilters],
	);
	const shouldShowSpotlight = useMemo(() => {
		if (isMobile) return false;
		const isInternalSort = sort === SearchConstants.INTERNAL_REFERRER_SORT;
		const hasAppliedDistanceFilter = appliedFilters.some(
			(f) => f.getData().config.id === 'distance',
		);
		const hasAppliedNonBowOrDistanceFilter = appliedFilters.some((f) => {
			const configId = f.getData().config.id;
			return configId !== 'distance' && configId !== 'best-of-weddings';
		});
		return (
			isInternalSort &&
			!(hasAppliedDistanceFilter && !hasAppliedNonBowOrDistanceFilter)
		);
	}, [isMobile, sort, appliedFilters]);

	return useMemo(
		() => ({
			shouldShowSpotlight,
			isCurrentBowFilterApplied,
		}),
		[shouldShowSpotlight, isCurrentBowFilterApplied],
	);
};
